
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_1crp2_94",
  "root-no-actions": "awsui_root-no-actions_2qdw9_1crp2_109",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_1crp2_109",
  "root-variant-h1-refresh": "awsui_root-variant-h1-refresh_2qdw9_1crp2_112",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_1crp2_115",
  "root-has-description": "awsui_root-has-description_2qdw9_1crp2_115",
  "root-variant-h2-refresh": "awsui_root-variant-h2-refresh_2qdw9_1crp2_118",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_1crp2_121",
  "root-variant-h3-refresh": "awsui_root-variant-h3-refresh_2qdw9_1crp2_124",
  "root-no-wrap": "awsui_root-no-wrap_2qdw9_1crp2_127",
  "main": "awsui_main_2qdw9_1crp2_131",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_1crp2_139",
  "main-variant-h1-refresh": "awsui_main-variant-h1-refresh_2qdw9_1crp2_142",
  "main-variant-h2": "awsui_main-variant-h2_2qdw9_1crp2_148",
  "main-variant-h3": "awsui_main-variant-h3_2qdw9_1crp2_148",
  "main-variant-h2-refresh": "awsui_main-variant-h2-refresh_2qdw9_1crp2_154",
  "actions": "awsui_actions_2qdw9_1crp2_161",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_1crp2_165",
  "actions-variant-h1-refresh": "awsui_actions-variant-h1-refresh_2qdw9_1crp2_168",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_1crp2_171",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_1crp2_171",
  "actions-variant-h2-refresh": "awsui_actions-variant-h2-refresh_2qdw9_1crp2_177",
  "actions-variant-h3-refresh": "awsui_actions-variant-h3-refresh_2qdw9_1crp2_180",
  "title": "awsui_title_2qdw9_1crp2_184",
  "title-variant-h1": "awsui_title-variant-h1_2qdw9_1crp2_190",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_1crp2_193",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_1crp2_193",
  "title-variant-h2-refresh": "awsui_title-variant-h2-refresh_2qdw9_1crp2_199",
  "info": "awsui_info_2qdw9_1crp2_206",
  "description": "awsui_description_2qdw9_1crp2_210",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_1crp2_215",
  "description-variant-h1-refresh": "awsui_description-variant-h1-refresh_2qdw9_1crp2_220",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_1crp2_223",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_1crp2_228",
  "description-variant-h3-refresh": "awsui_description-variant-h3-refresh_2qdw9_1crp2_234",
  "heading": "awsui_heading_2qdw9_1crp2_238",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_1crp2_247",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_1crp2_252",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_1crp2_257",
  "heading-text": "awsui_heading-text_2qdw9_1crp2_263",
  "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_1crp2_266",
  "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_1crp2_274",
  "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_1crp2_282",
  "counter": "awsui_counter_2qdw9_1crp2_291"
};
  